import { Loader } from '@sgme/ui';
import { DocumentFormat } from 'epic/common-form/Documentation';
import { IntlKey } from 'locales';
import { DocumentType } from 'models/documents/DocumentType';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { EssentialErrorDoc } from 'routes/essential-workspace/components/quote-panel/collapse/docs-item/error-doc';
import { useDownloadEssentialFormDoc } from 'routes/essential-workspace/components/quote-panel/collapse/docs-item/use-download-form-doc';

type EssentialDocProps = {
  formats: Array<DocumentFormat>;
  language: string;
  type: DocumentType;
  canShowError?: boolean;
};

export function EssentialDocument({ formats, language, type, canShowError }: EssentialDocProps) {
  const { onDownload, isLoading, error, errorContext } = useDownloadEssentialFormDoc(type, language);
  const isMultiFormat = formats && formats.length > 1;

  const variant = error ? 'flat-danger' : 'flat-primary';

  if (isMultiFormat) {
    return (
      <div className="flex-x">
        <Dropdown align="end" as={ButtonGroup}>
          <Dropdown.Toggle variant={variant} disabled={isLoading} className="px-1">
            <div className="flex-x gap-2">
              <DocLanguage language={language} />
              {isLoading && <Loader size="sm" purpose="spinner" />}
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {formats.map(format => (
              <Dropdown.Item key={format} className="flex-x justify-content-between" onClick={() => onDownload(format)}>
                {format}
                <i className="icon fs-3">save_alt</i>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        {!!error && <EssentialErrorDoc error={error} errorContext={errorContext} initOpen={canShowError} />}
      </div>
    );
  }

  return (
    <div className="flex-x">
      <Button
        variant={variant}
        className="flex-x px-1 gap-2"
        onClick={() => onDownload(formats[0])}
        disabled={isLoading}
      >
        {isLoading ? <Loader size="sm" purpose="spinner" /> : <DocLanguage language={language} />}
      </Button>

      {!!error && <EssentialErrorDoc error={error} errorContext={errorContext} initOpen={canShowError} />}
    </div>
  );
}

function DocLanguage({ language }: { language?: string }) {
  if (!language) {
    return null;
  }
  return <FormattedMessage id={`languageCode.${language}` as IntlKey} defaultMessage={language} />;
}
